import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const HoldingSignIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g>
      <path
        d="M 158.789062 86.588542 C 201.171875 28.320313 278.320312 122.135417 224.088542 160.546875 C 181.966146 190.429688 132.486979 143.880208 152.213542 103.385417 "
        transform="matrix(0.06,0,0,0.06,0,0)"
        fill="none"
        stroke="currentColor"
        strokeWidth={16}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeOpacity={0.898039}
      />
      <path
        d="M 126.432292 230.924479 C 126.432292 230.924479 155.729167 199.674479 190.494792 198.763021 C 225.260417 197.916667 260.286458 221.484375 268.945312 227.34375 "
        transform="matrix(0.06,0,0,0.06,0,0)"
        fill="none"
        stroke="currentColor"
        strokeWidth={16}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeOpacity={0.898039}
      />
      <path
        d="M 92.057292 233.072917 C 146.614583 232.421875 177.669271 232.161458 185.286458 232.161458 C 218.489583 232.161458 323.632812 230.338542 323.632812 234.309896 C 323.632812 238.28125 323.632812 249.023438 323.632812 255.46875 C 323.632812 261.914062 323.632812 321.875 323.632812 326.627604 C 323.632812 331.380208 317.382812 331.380208 301.432292 331.380208 C 285.546875 331.380208 96.354167 335.026042 85.872396 331.380208 C 75.325521 327.669271 77.864583 268.75 77.864583 263.411458 C 77.864583 258.072917 77.864583 250.911458 77.864583 246.875 "
        transform="matrix(0.06,0,0,0.06,0,0)"
        fill="none"
        stroke="currentColor"
        strokeWidth={12}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeOpacity={0.898039}
      />
      <path
        d="M 323.4375 267.317708 C 327.148438 267.317708 338.346354 269.596354 335.546875 276.171875 C 333.658854 280.46875 329.622396 282.682292 323.4375 282.682292 "
        transform="matrix(0.06,0,0,0.06,0,0)"
        fill="none"
        stroke="currentColor"
        strokeWidth={16}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeOpacity={0.898039}
      />
      <path
        d="M 77.604167 270.377604 C 69.205729 269.53125 64.973958 270.572917 64.973958 273.502604 C 64.973958 277.994792 70.963542 282.682292 77.604167 282.682292 "
        transform="matrix(0.06,0,0,0.06,0,0)"
        fill="none"
        stroke="currentColor"
        strokeWidth={16}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeOpacity={0.898039}
      />
    </g>
  </SvgIcon>
);

export default HoldingSignIcon;
